// NO EDITAR A MANO
import type {FooterLinkLegal as Modulo} from "../../../../footer/link_legal";

import link_configuracion from "./link_configuracion";
import link_cookies from "./link_cookies";
import link_legal from "./link_legal";
import link_privacidad from "./link_privacidad";

class FooterLinkLegal implements Modulo {
    /* STATIC */
    // public static ID: string = "footer.link_legal";
    // public static VERSION: string = "2024.12.2-143826";
    // public static HASH: string = "a1d98549a00b7107762e75832556a030";

    /* INSTANCE */
    public readonly link_configuracion: string;
    public readonly link_cookies: string;
    public readonly link_legal: string;
    public readonly link_privacidad: string;

    public constructor() {
        this.link_configuracion = link_configuracion;
        this.link_cookies = link_cookies;
        this.link_legal = link_legal;
        this.link_privacidad = link_privacidad;
    }

}

export default new FooterLinkLegal();
